import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-total-page-items',
    templateUrl: './total-page-items.component.html',
    styles: [],
    standalone: false
})
export class TotalPageItemsComponent implements OnInit {

  @Input('totalItems') totalItems;
  constructor() { }

  ngOnInit() {
  }

}
